import { postRequest } from '../../../shared/utils';

export async function validateHtzService(htz: string, screenGridId: number) {
  const body = {
    columns: ['npi_id', 'project_id', 'khk_pkey'],
    screenGridId,
    schema: 'npi',
    table: 'npi',
    key: 'npi_htz',
    value: htz,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }

  return data;
}
